<template>
  <div>
    <v-card class="mx-4 mt-6" shaped elevation="12" max-width="344" outlined>
      <v-list-item three-line>
        <v-autocomplete
          class="my-4"
          chips
          clearable
          deletable-chips
          multiple
          filled
          rounded
          small-chips
          solo
          solo-inverted
          v-model="selectedColumns"
          label="Select Columns"
          :items="tableColumns"
          @focusout="getSelectedTableColumns()"
        ></v-autocomplete>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["selTable"],
  mounted() {
    this.selectedTable = this.selTable;
    this.getTableColumns();
  },
  watch: {
    selTable(table) {
      this.selectedTable = table;
      this.getTableColumns();
    },
  },
  data: () => ({
    selectedTable: null,
    selectedColumns: [],
    tableHeader: [],
    queryFilter: "1=1",
    tableColumns: [],
  }),
  methods: {
    formatColumnNames(tableName) {
      let table = "";
      if (tableName && tableName.includes("_")) {
        table = tableName.replace("_", " ");
      } else {
        table = tableName;
      }

      table = table.split(" ");
      if (table.length > 1) {
        let parts = "";
        table.forEach((tab) => {
          parts += tab.toUpperCase() + " ";
        });
        table = parts;
      } else {
        table = table[0].toUpperCase();
      }
      return table;
    },
    getTableColumns() {
      this.tableColumns = [];
      this.selectedColumns = [];

      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/get-columns",
          { table: this.selectedTable },
          this.getAccessToken
        )
        .then((tableColumns) => {
          //filter and remove id, emis and related stuff out
          const filteredColumns = tableColumns.filter((column) => {
            return (
              column != "id" && column != "emis" && !column.includes("_at")
            );
          });

          filteredColumns.forEach((column) => {
            this.tableColumns.push({
              text: this.formatColumnNames(column),
              value: column,
            });
          });

          //initially select all filtered columns
          this.tableColumns.forEach((column) => {
            this.selectedColumns.push(column.value);
          });

          //broadcast columns
          this.getSelectedTableColumns();
          this.$store.commit("setLoader", false);
        });
    },
    getSelectedTableColumns() {
      this.$emit("columns-selected", this.selectedColumns);
    },
  },
};
</script>

<style></style>
